export const formatDateDDMMYYYY = (date) => {
	if (!(date instanceof Date)) return "";
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	return `${day}-${month}-${year}`;
};

export const validDate = (dateString) => {
	const date = new Date(dateString);
	const limit = new Date("3000-01-01");
	return !isNaN(date.getTime()) && date < limit;
};
